<template>
  <footer class="footer">
    <section class="footer__container footer__container--wrap">
      <div class="footer__col top">
        <router-link to="/">
          <img
            :src="require('@/projects/people/assets/img/footer/logo.png')"
            class="footer__logo"
            alt="логотип"
          >
        </router-link>
      </div>
      <div class="footer__col left">
        <p class="footer__rights a-font__xs">
          ©{{ new Date().getFullYear() }}
          {{ $t('general.copyright') }}
        </p>
        <AppPersonalAgreementDialog>
          <a
            class="footer__privacy a-font__xs"
            href="/my/files/policy.pdf"
            target="_blank"
          >
            {{ $t('footer.policy') }}
          </a>
        </AppPersonalAgreementDialog>
      </div>
    </section>
  </footer>
</template>

<script setup lang="ts">
import AppPersonalAgreementDialog from '@/shared/components/AppPersonalAgreementDialog/AppPersonalAgreementDialog.vue';
</script>

<style lang="scss">
@import './TheFooter.scss';
</style>
